import React from 'react';
const IconMiscCreditCardFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 4H2V8H22V4Z" fill="#2D2E2E"/>
<path d="M2 20H22V11H2V20ZM11 14H13V16H11V14ZM4 14H9V16H4V14Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscCreditCardFill;